<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    
    <v-dialog v-model="dialog.form"
      :width="selected.menu !== 1 ? 625 : 1000"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            {{ form.id.length > 0 ? 'Ubah Data' : 'Tambah' }} Calon Peserta
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="reset()">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <div class="px-5 mb-3" v-if="form.id.length < 1">
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#00ACC1"
            dense
            grow
            class="d-flex justify-start">
            <v-tab
              v-for="(item, index) in menu"
              :key="index"
              class="px-0 mx-1"
              :style="index < 1 ? 'min-width: 35px; max-width: 35px;' : 'min-width: 85px; max-width: 85px;'">
              <span class="body-2 text-capitalize" :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item }}
              </span>
            </v-tab>
          </v-tabs>
        </div>

        <v-card-text class="pt-2" :style="selected.menu < 1 ? 'height: 750px;' : ''">
          <ValidationObserver ref="form">
            <v-form>
              <v-card flat v-if="selected.menu === 0">
                <div>
                  <p class="mb-2">
                    Kode Calon Peserta (bisa dikosongi)
                  </p>

                  <v-text-field
                    v-on:keyup.enter="save()"
                    :style="rps === 'xs' ? '' : 'width: 35%;'"
                    dense
                    outlined
                    placeholder="Ex. AMJ001"
                    color="#00ACC1"
                    v-model="form.code">
                  </v-text-field>
                </div>

                <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                  <p class="mb-2">
                    <span class="red--text">*</span>
                    Nama Calon Peserta
                  </p>

                  <v-text-field
                    v-on:keyup.enter="save()"
                    :style="rps === 'xs' ? '' : 'width: 70%;'"
                    dense
                    outlined
                    placeholder="Ex. John Doe"
                    color="#00ACC1"
                    v-model="form.name"
                    :error-messages="errors"
                    require>
                  </v-text-field>
                </ValidationProvider>

                <ValidationProvider name="mobile_phone_number" rules="min:10|max:14" v-slot="{ errors }">
                  <p class="mb-2">
                    Telepon (bisa dikosongi)
                  </p>

                  <v-text-field
                    v-on:keyup.enter="save()"
                    :style="rps === 'xs' ? '' : 'width: 50%;'"
                    type="number"
                    dense
                    outlined
                    placeholder="Ex. 081XXXXXXXXX"
                    color="#00ACC1"
                    v-model="form.mobile_phone_number"
                    :counter="14" 
                    :error-messages="errors">
                  </v-text-field>
                </ValidationProvider>

                <div>
                  <p class="mb-2">
                    Nomor KTP (bisa dikosongi)
                  </p>

                  <v-text-field
                    v-on:keyup.enter="save()"
                    :style="rps === 'xs' ? '' : 'width: 50%;'"
                    type="number"
                    dense
                    outlined
                    placeholder="Ex. 331XXXXXXXXXXXXX"
                    color="#00ACC1"
                    v-model="form.ktp">
                  </v-text-field>
                </div>

                <div class="mb-6">
                  <p class="mb-2">
                    Gambar KTP (bisa dikosongi)
                  </p>

                  <uploadimage v-model="images">
                    <div slot="activator">
                      <v-card
                        outlined
                        class="d-flex align-center justify-center cursor-pointer"
                        width="275"
                        height="175">
                        <v-avatar v-if="!process.image"
                          v-ripple
                          tile 
                          width="273"
                          height="173" 
                          class="cursor-pointer">
                          <v-img 
                            v-if="form.ktp_image_url.length > 0"
                            contain
                            width="273"
                            height="173"
                            alt="VENOM"
                            :src="form.ktp_image_url">
                          </v-img>

                          <v-icon v-else large>mdi-camera-plus</v-icon>
                        </v-avatar>

                        <v-progress-circular v-else
                          indeterminate
                          color="#00ACC1">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </uploadimage>
                </div>

                <div>
                  <p class="mb-2">
                    Alamat (bisa dikosongi)
                  </p>

                  <v-textarea
                    v-on:keyup.enter="save()"
                    outlined
                    dense
                    placeholder="Ex. Jl. Ahmad Yani No. 77"
                    rows="3"
                    color="#00ACC1"
                    v-model="form.address">
                  </v-textarea>
                </div>

                <ValidationProvider name="user_id" rules="required" v-slot="{ errors }">
                  <p class="mb-2">
                    <span class="red--text">*</span>
                    Marketing
                  </p>

                  <v-autocomplete
                    v-on:keyup.enter="save()"
                    :style="rps === 'xs' ? '' : 'width: 60%;'"
                    dense
                    outlined
                    color="#00ACC1"
                    placeholder="Ex. John Doe"
                    :loading="process.user"
                    :items="list.user"
                    item-text="name"
                    item-value="id"
                    item-color="cyan darken-1"
                    v-model="form.user_id"
                    :error-messages="errors"
                    require>
                    <template v-slot:selection="data">
                      <v-avatar left size="25">
                        <v-img 
                          :src="data.item.image_url !== '' ? data.item.image_url : require('@/assets/image/member-default.jpg')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#00ACC1">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <span class="ml-2">
                        {{ data.item.name }}
                      </span>
                    </template>

                    <template v-slot:item="data">
                      <v-list-item-avatar>
                        <v-img 
                          :src="data.item.image_url !== '' ? data.item.image_url : require('@/assets/image/member-default.jpg')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#00ACC1">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="text-first text-capitalize">
                          {{ data.item.name }}
                        </v-list-item-title>
                        
                        <v-list-item-subtitle class="font-weight-light text-second text-capitalize">
                          {{ data.item.position }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>

                <ValidationProvider name="status" rules="required" v-slot="{ errors }" v-if="form.id.length < 1">
                  <p class="mb-2">
                    <span class="red--text">*</span>
                    Status Kunjungan
                  </p>

                  <v-select
                    :style="rps === 'xs' ? '' : 'width: 40%;'"
                    :items="[
                      {
                        text: 'Belum Dikunjungi',
                        value: 'belum dikunjungi'
                      },
                      {
                        text: 'Sudah Dikunjungi',
                        value: 'sudah dikunjungi'
                      }
                    ]"
                    placeholder="Pilih Status Kunjungan"
                    outlined
                    dense
                    color="#00ACC1"
                    item-text="text"
                    item-value="value"
                    item-color="cyan darken-1"
                    v-model="form.status"
                    :error-messages="errors"
                    require>
                  </v-select>
                </ValidationProvider>

                <div>
                  <p class="mb-2">
                    Catatan (bisa dikosongi)
                  </p>

                  <v-textarea
                    outlined
                    dense
                    placeholder="Ex. Peserta baru."
                    hide-details
                    rows="3"
                    color="#00ACC1"
                    v-model="form.catatan">
                  </v-textarea>
                </div>
              </v-card>

              <v-card flat style="border: 1px solid #E0E0E0;" v-if="selected.menu === 1">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="5">
                      <ValidationProvider name="user_id" rules="required" v-slot="{ errors }">
                        <p class="mb-2">
                          <span class="red--text">*</span>
                          Marketing
                        </p>

                        <v-autocomplete
                          v-on:keyup.enter="save()"
                          dense
                          outlined
                          color="#00ACC1"
                          placeholder="Ex. John Doe"
                          :loading="process.user"
                          :items="list.user"
                          item-text="name"
                          item-value="id"
                          item-color="cyan darken-1"
                          return-object
                          v-model="form.marketing_object"
                          :error-messages="errors"
                          require>
                          <template v-slot:selection="data">
                            <v-avatar left size="25">
                              <v-img 
                                :src="data.item.image_url !== '' ? data.item.image_url : require('@/assets/image/member-default.jpg')">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="#00ACC1">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>

                            <span class="ml-2">
                              {{ data.item.name }}
                            </span>
                          </template>

                          <template v-slot:item="data">
                            <v-list-item-avatar>
                              <v-img 
                                :src="data.item.image_url !== '' ? data.item.image_url : require('@/assets/image/member-default.jpg')">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="#00ACC1">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="text-first text-capitalize">
                                {{ data.item.name }}
                              </v-list-item-title>
                              
                              <v-list-item-subtitle class="font-weight-light text-second text-capitalize">
                                {{ data.item.position }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="12" md="5">
                      <ValidationProvider name="status" rules="required" v-slot="{ errors }" v-if="form.id.length < 1">
                        <p class="mb-2">
                          <span class="red--text">*</span>
                          Status Kunjungan
                        </p>

                        <v-select
                          :items="[
                            {
                              text: 'Belum Dikunjungi',
                              value: 'belum dikunjungi'
                            },
                            {
                              text: 'Sudah Dikunjungi',
                              value: 'sudah dikunjungi'
                            }
                          ]"
                          placeholder="Pilih Status Kunjungan"
                          outlined
                          dense
                          color="#00ACC1"
                          item-text="text"
                          item-value="value"
                          item-color="cyan darken-1"
                          v-model="form.status"
                          :error-messages="errors"
                          require>
                        </v-select>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <p class="text-first mb-0">
                    Setelah memilih marketing dan status kunjungan diatas, kemudian pilih data peserta yang akan dijadikan calon peserta dibawah ini :
                  </p>
                </v-card-text>

                <v-divider style="border: 2px solid #f0f0f0;"/>

                <v-card-text>
                  <p class="font-weight-bold text-first mb-0">
                    Cari Peserta
                  </p>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        outlined
                        single-line
                        hide-details
                        color="#00ACC1"
                        placeholder="Kode Peserta . . ."
                        append-icon="mdi-numeric"
                        clearable
                        v-model="search.dialog.code"
                        @click:clear="search.dialog.code = ''; fetchParticipant();"
                        v-on:keyup.enter="fetchParticipant()">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        outlined
                        single-line
                        hide-details
                        color="#00ACC1"
                        placeholder="Nama Peserta . . ."
                        append-icon="mdi-account-circle-outline"
                        clearable
                        v-model="search.dialog.name"
                        @click:clear="search.dialog.name = ''; fetchParticipant();"
                        v-on:keyup.enter="fetchParticipant()">
                      </v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="4">
                      <v-text-field
                        dense
                        outlined
                        single-line
                        hide-details
                        color="#00ACC1"
                        placeholder="Alamat Peserta . . ."
                        append-icon="mdi-magnify"
                        clearable
                        v-model="search.dialog.address"
                        @click:clear="search.dialog.address = ''; fetchParticipant();"
                        v-on:keyup.enter="fetchParticipant()">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-data-table
                  v-model="selected.participant.row"
                  ref="table-grid"
                  class="table-grid text-capitalize"
                  :height="`calc(100vh - ${pagination.participant.total_data > 0 ? '300px' : '228px'})`"
                  fixed-header
                  show-select
                  :loading="process.participant"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options.participant"
                  :headers="headers.participant"
                  :items="list.participant"
                  :items-per-page="100"
                  item-key="participant_id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAllParticipant($event)"
                  hide-default-footer>
                </v-data-table>

                <pagination v-if="pagination.participant.total_data > 0"
                  @changePage="fetchParticipant($event)" 
                  @reloadPage="fetchParticipant($event)"
                  :model="pagination.participant"/>
              </v-card>

              <v-card flat v-if="selected.menu === 2">
                <p class="body-1 font-weight-light text-first">
                  Sebelum import excel, silahkan download terlebih dahulu template excel dibawah ini :
                </p>

                <v-btn
                  color="blue"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text px-2"
                  href="https://venom-amj-api.monsterdev.web.id/files/export/template-import-calon-peserta.xlsx"
                  target="_blank">
                  <v-icon small class="mr-1">mdi-download</v-icon>
                  Download Template
                </v-btn>

                <p class="body-1 font-weight-bold mt-6 mb-2">
                  Upload Excel
                </p>

                <p class="body-1 font-weight-light text-first">
                  Setelah mendownload dan mengisi data calon peserta, kemudian upload file tersebut di bawah ini :
                </p>

                <p class="font-italic text-second" v-if="form.data_array.length > 0">
                  *File excel berhasil di upload, jika ingin mengganti klik tombol <b class="text-first">Ganti File Excel</b>.
                </p>

                <uploadexcel v-model="excels">
                  <div slot="activator">
                    <v-btn
                      color="#00ACC1"
                      elevation="0"
                      :disabled="process.excel"
                      :loading="process.excel"
                      class="body-2 font-weight-bold text-capitalize white--text px-2">
                      <v-icon small class="mr-1">
                        {{ form.data_array.length > 0 ? 'mdi-file-check-outline' : 'mdi-file-upload-outline' }}
                      </v-icon>

                      {{ form.data_array.length > 0 ? 'Ganti File Excel' : 'Upload File Excel' }}
                    </v-btn>
                  </div>
                </uploadexcel>
              </v-card>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      width="500"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Hapus Data Calon Peserta
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.delete = false; selected.delete = [];">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="body-1 font-weight-light text-first mt-4">
          Apakah anda yakin menghapus data calon peserta yang anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.delete = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.detail"
      width="550"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Detail Calon Peserta
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.detail = false; detail = {};">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12" md="7">
              <div>
                <p class="text-second mb-0">
                  Kode Calon Peserta
                </p>

                <p class="body-1">
                  {{ detail.code === '' ? '-' : detail.code }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Nama Calon Peserta
                </p>

                <p class="body-1">
                  {{ detail.name }}
                </p>
              </div>
              
              <div>
                <p class="text-second mb-0">
                  Telepon
                </p>

                <p class="body-1">
                  {{ detail.mobile_phone_number }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Nomor KTP
                </p>

                <p class="body-1 text-capitalize">
                  {{ detail.ktp === '' ? '-' : detail.ktp }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Alamat
                </p>

                <p class="body-1 text-capitalize">
                  {{ detail.address === '' ? '-' : detail.address }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Nama Petugas
                </p>

                <p class="body-1 text-capitalize">
                  {{ detail.marketing_name }} ({{ detail.marketing_code }})
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Catatan
                </p>

                <p class="body-1 text-capitalize">
                  {{ detail.catatan === '' ? '-' : detail.catatan }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Tanggal Input
                </p>

                <p class="body-1 text-capitalize">
                  {{ detail.input_datetime | datetime }}
                </p>
              </div>
            </v-col>

            <v-col cols="12" md="5">
              <v-img 
                class="border-radius"
                contain
                alt="VENOM"
                width="275"
                height="175"
                :src="detail.ktp_image_url !== '' ? detail.ktp_image_url : require('@/assets/image/empty.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#00ACC1">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            @click="dialog.detail = false; detail = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.filter"
      width="550"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Filter Data
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.filter = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="mt-4">
          <v-form>
            <p class="body-1 font-weight-bold text-first mb-1">
              Filter General
            </p>

            <v-row>
              <v-col cols="12" md="8">
                <div>
                  <p class="mb-2">
                    Nama Admin
                  </p>

                  <v-text-field
                    dense
                    outlined
                    placeholder="Ex. John Doe"
                    color="#00ACC1"
                    hide-details
                    v-model="search.filter.admin">
                  </v-text-field>
                </div>
              </v-col>
              
              <v-col cols="12" md="8">
                <div>
                  <p class="mb-2">
                    Nama Marketing
                  </p>

                  <v-text-field
                    dense
                    outlined
                    placeholder="Ex. John Doe"
                    color="#00ACC1"
                    hide-details
                    v-model="search.filter.marketing">
                  </v-text-field>
                </div>
              </v-col>

              <v-col cols="12" md="4">
                <div>
                  <p class="mb-2">
                    Kode Marketing
                  </p>

                  <v-text-field
                    dense
                    outlined
                    placeholder="Ex. AMJ001"
                    color="#00ACC1"
                    hide-details
                    v-model="search.filter.code">
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <p class="body-1 font-weight-bold text-first mt-3 mb-1">
              Filter Tanggal
            </p>

            <v-row>
              <v-col cols="12" md="5">
                <div>
                  <p class="mb-2">
                    Tanggal Input (Lebih Dari)
                  </p>
                  
                  <v-menu
                    ref="start"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.date.start">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.date.start"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Input (Lebih Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.date.start = ''; search.filter.date.end = '';"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.date.start"
                      @input="search.picker.date.start = false"
                      v-on:change="search.filter.date.end = ''">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="5">
                <div>
                  <p class="mb-2">
                    Tanggal Input (Kurang Dari)
                  </p>
                  
                  <v-menu
                    ref="end"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.date.end">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.date.end"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Input (Kurang Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.date.end = ''"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.date.end"
                      :min="search.filter.date.start"
                      @input="search.picker.date.end = false">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.filter = false; fetch();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.location"
      width="1000"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Lokasi
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.location = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="mt-4">
          <gmap-map
            ref="gmap"
            :center="center"
            :zoom="12"
            :scrollwheel="false"
            style="width:100%; height: calc(100vh - 275px);">
    
            <gmap-marker
              :position="selected.location.latlng"
              :icon="selected.location.icon">
            </gmap-marker>
          </gmap-map>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-card flat style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="9" class="d-flex align-center">
                 <div>
                  <v-btn
                    elevation="0"
                    dark
                    color="#00ACC1"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center"
                    @click="dialog.filter = true">
                    <v-icon size="18">mdi-filter-outline</v-icon>

                    <span class="ml-1">
                      Filter
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3">
                  <v-btn
                    elevation="0"
                    style="background: #00acc133;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                    @click="reset()">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length === 1">
                  <v-btn
                    elevation="0"
                    style="background: #2196f333;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="reset(selected.row[0])">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length > 0">
                  <v-btn
                    elevation="0"
                    style="background: #f4403433;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length === 1">
                  <v-btn
                    elevation="0"
                    style="background: #e0e0e0;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center text-second"
                    @click="dialog.detail = true; detail = selected.row[0]">
                    <v-icon size="18">mdi-information-outline</v-icon>

                    <span class="ml-1">
                      Detail
                    </span>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" md="3" class="d-flex align-center">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  color="#00ACC1"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search.name"
                  @click:clear="search.name = ''; fetch();"
                  v-on:keyup.enter="fetch()">
                </v-text-field>

                <div class="ml-3" v-if="pagination.data.total_data > 0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="#00ACC1"
                        elevation="0"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        :disabled="process.print"
                        :loading="process.print"
                        @click="prints()"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>
                    
                    <span>
                      Print
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid-candidate text-capitalize"
            :height="`calc(100vh - ${pagination.data.total_data > 0 ? '300px' : '228px'})`"
            fixed-header
            show-select
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options.data"
            :headers="headers.data"
            :items="list.data"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            hide-default-footer>
            <template v-slot:[`item.status_peserta`]="{ item }">
              <span :class="item.status_peserta === 'Tidak Berhasil' || item.status_peserta === 'tidak berhasil' ? 'red--text' : 'green--text'">
                {{ item.status_peserta }}
              </span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <span :class="item.status === 'Belum Dikunjungi' || item.status === 'belum dikunjungi' ? 'orange--text' : 'green--text'">
                {{ item.status }}
              </span>
            </template>

            <template v-slot:[`item.input_datetime`]="{ item }">
              {{ item.input_datetime | datetime }}
            </template>

            <template v-slot:[`item.location_object`]="{ item }">
              <v-btn v-if="Object.keys(item.location_object).length > 0"
                outlined
                small
                color="cyan darken-1"
                class="text-capitalize"
                @click="dialog.location = true; setLatlng(item.location_object);">
                <v-icon small class="mr-1">mdi-map-marker-radius-outline</v-icon>
                Lokasi
              </v-btn>
            </template>
          </v-data-table>

          <pagination v-if="pagination.data.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination.data"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import { TokenService } from "../../../service/Storage.Service";
  import axios from "axios";
  import moment from "moment";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          delete: false,
          detail: false,
          snackbar: false,
          filter: false,
          location: false
        },
        search: {
          name: '',
          filter: {
            admin: '',
            marketing: '',
            code: '',
            date: {
              start: '',
              end: ''
            }
          },
          picker: {
            date: {
              start: false,
              end: false
            }
          },
          dialog: {
            code: '',
            name: '',
            address: ''
          }
        },
        selected: {
          menu: 0,
          row: [],
          delete: [],
          participant: {
            row: []
          },
          location: {}
        },
        center: {
          lat: -7.7400, 
          lng: 110.6646
        },
        menu: ['Baru', 'Pilih Peserta', 'Import Excel'],
        options: {
          data: {},
          participant: {}
        },
        headers: {
          data: [],
          participant: []
        },
        detail: {},
        list: {
          data: [],
          user: [],
          participant: []
        },
        pagination: {
          data: {},
          participant: {}
        },
        limit: 20,
        images: '',
        excels: '',
        form: {
          id: '',
          user_id: '',
          code: '',
          name: '',
          mobile_phone_number: '',
          ktp: '',
          ktp_image_url: '',
          address: '',
          catatan: '',
          status: 'belum dikunjungi',

          // MARKETING OBJECT
          marketing_object: '',

          // IMPORT EXCEL
          data_array: []
        },
        process: {
          load: false,
          image: false,
          form: false,
          user: false,
          print: false,
          excel: false,
          participant: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/uploadimage.vue'),
      uploadexcel: () => import(/* webpackPrefetch: true */ '@/components/uploadexcel.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      'images': {
        handler: function () {
          if (this.images) {
            this.process.image = this.images.process 
            
            if (!this.process.image) this.form.ktp_image_url = this.images.fileuri
          }
        },
        deep: true
      },
      'excels': {
        handler: function () {
          if (this.excels) {
            this.process.excel = this.excels.process 

            if (!this.process.excel) this.form.data_array = this.excels.data.success
          }
        },
        deep: true
      },
      'selected.menu': function(val) {
        this.form = {
          id: '',
          user_id: '',
          code: '',
          name: '',
          mobile_phone_number: '',
          ktp: '',
          ktp_image_url: '',
          address: '',
          catatan: '',
          status: 'belum dikunjungi',

          // MARKETING OBJECT
          marketing_object: '',

          // IMPORT EXCEL
          data_array: []
        }
        
        this.search.dialog = {
          code: '',
          name: '',
          address: ''
        }

        this.selected.participant.row = []

        if (val === 1) this.fetchParticipant()
      },
      'options.data': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      'options.participant': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetchParticipant(pagination)
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll(event) {
        if (!event.value) this.selected.row = []
      },
      handleToggleAllParticipant(event) {
        if (!event.value) this.selected.participant.row = []
      },
      async fetch(pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let SORT = this.options.data.sortBy.length < 1 ? '-id' : this.options.data.sortDesc[0] ? `-${this.options.data.sortBy[0]}` : this.options.data.sortBy[0]

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: SORT,
          search: this.search.name,
          'admin_name[lse]': this.search.filter.admin,
          'marketing_name[lse]': this.search.filter.marketing,
          'marketing_code[lse]': this.search.filter.code,
          'input_datetime[gte]': this.search.filter.date.start,
          'input_datetime[lte]': this.search.filter.date.end
        }

        await get(`admin/candidates`, { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.headers.data = [
              {
                text: 'Kode Calon Peserta',
                width: '200px',
                value: 'code'
              },
              {
                text: 'Nama Calon Peserta',
                width: '200px',
                value: 'name'
              },
              {
                text: 'Telepon',
                width: '150px',
                value: 'mobile_phone_number'
              },
              {
                text: 'Nomor KTP',
                width: '150px',
                value: 'ktp'
              },
              {
                text: 'Alamat',
                width: '400px',
                value: 'address'
              },
              {
                text: 'Nama Admin',
                width: '200px',
                value: 'admin_name'
              },
              {
                text: 'Nama Marketing',
                width: '200px',
                value: 'marketing_name'
              },
              {
                text: 'Kode Marketing',
                width: '150px',
                value: 'marketing_code'
              },
              {
                text: 'Status Calon Peserta',
                width: '175px',
                value: 'status_peserta'
              },
              {
                text: 'Status Kunjungan',
                width: '175px',
                value: 'status'
              },
              {
                text: 'Catatan',
                width: '400px',
                value: 'catatan'
              },
              {
                text: 'Tanggal Input',
                width: '175px',
                value: 'input_datetime'
              },
              {
                text: 'Lokasi',
                width: '100px',
                value: 'location_object'
              }
            ]
            
            this.list.data = res.results.data
            this.pagination.data = res.results.pagination

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
          }
        })
      },
      async fetchUser() {
        this.process.user = true

        let params = {
          limit: 1000000,
          sort: '-id',
          'role[eq]': 'staff',
          'position[eq]': 'marketing'
        }

        await get(`admin/user`, { params }).then(response => {
          let res = response.data

          this.process.user = false

          if (res.status === 200) {
            this.list.user = res.results.data
          }
        })
      },
      async fetchParticipant(pagination = { row: 20, page: 1 }) {
        this.process.participant = true

        this.limit = pagination.row

        let SORT = this.options.data.sortBy.length < 1 ? '-id' : this.options.data.sortDesc[0] ? `-${this.options.data.sortBy[0]}` : this.options.data.sortBy[0]

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: SORT,
          code: this.search.dialog.code,
          name: this.search.dialog.name,
          address: this.search.dialog.address
        }

        await get(`admin/candidates/peserta`, { params }).then(response => {
          let res = response.data

          this.process.participant = false

          if (res.status === 200) {
            this.headers.participant = [
              {
                text: 'Kode',
                width: '100px',
                value: 'participant_code'
              },
              {
                text: 'Nama Lengkap',
                width: '200px',
                value: 'participant_name'
              },
              {
                text: 'Telepon',
                width: '150px',
                value: 'participant_mobilephone'
              },
              {
                text: 'Alamat',
                width: '250px',
                value: 'participant_address'
              }
            ]
            
            this.list.participant = res.results.data
            this.pagination.participant = res.results.pagination

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
          }
        })
      },
      reset(item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = !this.dialog.form ? true : false

        this.selected.menu = 0

        if (this.dialog.form) this.fetchUser()

        this.form = {
          id: item === undefined ? '' : item.id,
          user_id: item === undefined ? '' : item.marketing_id,
          code: item === undefined ? '' : item.code,
          name: item === undefined ? '' : item.name,
          mobile_phone_number: item === undefined ? '' : item.mobile_phone_number,
          ktp: item === undefined ? '' : item.ktp,
          ktp_image_url: item === undefined ? '' : item.ktp_image_url,
          address: item === undefined ? '' : item.address,
          catatan: item === undefined ? '' : item.catatan,
          status: item === undefined ? 'belum dikunjungi' : item.status,

          // MARKETING OBJECT
          marketing_object: '',

          // IMPORT EXCEL
          data_array: []
        }

        this.process.form = false

        this.message.error = ''
      },
      async save() {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          if (this.selected.menu === 1) {
            let data = this.selected.participant.row
            
            for(let i = 0; i < data.length; i++) {
              this.form.data_array.push({
                code: data[i].participant_code,
                name: data[i].participant_name,
                mobile_phone_number: data[i].participant_mobilephone,
                ktp: '',
                address: data[i].participant_address,
                marketing_code: this.form.marketing_object.code,
                marketing_name: this.form.marketing_object.name,
                catatan: '',
                status: this.form.status
              })
            }
          }

          let url = this.form.id.length < 1 && this.form.data_array.length < 1 ? `admin/candidates/add` : 
                    this.form.id.length > 0 && this.form.data_array.length < 1 ? `admin/candidates/update` : `admin/candidates/import`
          
          this.process.form = true
          
          await post(url, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.selected.menu = 0
              
              this.dialog.snackbar = true
              this.message.success = res.message

              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      },
      toDelete() {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes() {
        this.message.error = ''

        this.process.form = true

        await post(`admin/candidates/deletes`, {
          data: {
            id_array: this.selected.delete
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      },
      async prints () {
        this.message.error = ''

        this.process.print = true

        let SORT = this.options.data.sortBy.length < 1 ? '-id' : this.options.data.sortDesc[0] ? `-${this.options.data.sortBy[0]}` : this.options.data.sortBy[0]

        let params = {
          sort: SORT,
          search: this.search.name,
          'admin_name[lse]': this.search.filter.admin,
          'marketing_name[lse]': this.search.filter.marketing,
          'marketing_code[lse]': this.search.filter.code,
          'input_datetime[gte]': this.search.filter.date.start,
          'input_datetime[lte]': this.search.filter.date.end
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/candidates/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `AMJ-CALON-PESERTA-${moment().format('DD-MMMM-YYYY', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },
      setLatlng (item) {
        this.selected.location = {}

        this.center = {
          lat: -7.7400, 
          lng: 110.6646
        }

        this.$gmapApiPromiseLazy().then(() => {
          if (Object.keys(item).length > 0) {
            this.center = {
              lat: parseFloat(item.latitude), 
              lng: parseFloat(item.longitude)
            }

            this.selected.location = {
              latlng: {
                lat: parseFloat(item.latitude), 
                lng: parseFloat(item.longitude)
              },
              icon: {
                url: require('@/assets/image/marker.png'),
                scaledSize: new google.maps.Size(50, 50),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 10)
              }
            }
          }
        })
      }
    }
  }
</script>

<style>
  .table-grid-candidate table > thead > tr > th:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-candidate table > thead > tr > th:nth-child(3) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 64px; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-candidate table > tbody > tr > td:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 1;
    background: white;
  }
  .table-grid-candidate table > tbody > tr > td:nth-child(3) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 64px; 
    z-index: 1;
    background: white;
  }
</style>